// @ts-check
import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faSquareFacebook,
  faSquareInstagram,
  faSquareXTwitter,
  faSquareYoutube
} from "@fortawesome/free-brands-svg-icons";
import { ASUFooter } from "@asu/component-header-footer";

const FooterSection = styled.div`
  footer {
    .footer-innovation-links {
      a {
        order: 2;
      }

      nav {
        order: 1;
      }
    }
    .footer-title-row {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
    }

    .footer-social-links {
      align-items: center;
      display: inline-flex;
      gap: 12px;
      margin-left: auto;
    }

    .footer-social-link {
      align-items: center;
      color: inherit;
      display: inline-flex;
      text-decoration: underline;
      transition: color 200ms ease;
    }

    .footer-social-link:hover,
    .footer-social-link:focus {
      color: var(--color-base-gold, #ffc627);
      cursor: pointer;
      text-decoration: none;
    }

    .footer-social-icon {
      font-size: 1.25rem;
    }

    #info-column.col-xl-3 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

function Footer({ siteName = "Faculty Sites", socials = {} }) {
  const hasContact = Object.prototype.hasOwnProperty.call(socials, "contact");
  const contactLink = hasContact ? socials.contact : "";
  const socialMediaLinks = [
    {
      key: "facebook",
      label: "Facebook",
      href: "#",
      icon: faSquareFacebook
    },
    {
      key: "twitter",
      label: "X (Twitter)",
      href: "#",
      icon: faSquareXTwitter
    },
    {
      key: "instagram",
      label: "Instagram",
      href: "#",
      icon: faSquareInstagram
    },
    {
      key: "youtube",
      label: "YouTube",
      href: "#",
      icon: faSquareYoutube
    },
    {
      key: "linkedin",
      label: "LinkedIn",
      href: "#",
      icon: faLinkedin
    }
  ]
    .map((link) => ({
      ...link,
      href: socials[link.key]
    }))
    .filter((link) => typeof link.href === "string" && link.href.trim());

  return (
    <FooterSection className="app-footer">
      <ASUFooter
        contact={{
          title: (
            <span className="footer-title-row">
              <span className="footer-site-name">{siteName}</span>
              {socialMediaLinks.length > 0 ? (
                <nav className="footer-social-links" aria-label="Social Media">
                  {socialMediaLinks.map((link) => (
                    <a
                      className="footer-social-link"
                      href={link.href}
                      key={link.label}
                      aria-label={link.label}
                      title={link.label}
                    >
                      <FontAwesomeIcon
                        className="footer-social-icon"
                        icon={link.icon}
                        aria-hidden="true"
                        focusable="false"
                      />
                    </a>
                  ))}
                </nav>
              ) : null}
            </span>
          ),
          contactLink: hasContact ? contactLink : undefined
        }}
      />
    </FooterSection>
  );
}

export { Footer };
